module.exports = __webpack_public_path__ + "img/tranquilo_sm.0f1a13a4.jpg";